const STORAGE_KEY = 'pdc_browser_key';

function randomKey(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getPersonalDataBrowserKey(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  let key = localStorage.getItem(STORAGE_KEY);
  if (!key) {
    key = randomKey();
    localStorage.setItem(STORAGE_KEY, key);
  }
  return key;
}
